import { VendorCommentsContainer } from 'components/order/comments/VendorCommentsContainer';
import React from 'react';

export const VendorCommentsPage: React.FC = () => {
  return <VendorCommentsContainer />;
};
